<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid">
    <div class="row" style="padding-top: 35px;">
      <div class="store-head">
        <a class="back-link" @click="$router.back()">
          ←
        </a>
        <div class="category-title">
          <div style="margin-top: 16px; font-size: 20px;"> পেমেন্টের ধরণ </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="! bkashOpen">
      <div class="payment-type d-flex justify-content-between align-items-center" @click="createPayment">
        <div class="payment-details d-flex align-items-center">
          <img src="@/assets/img/logos/bkash-icon-logo.svg" alt="bkash-logo">
          <div class="payment-title">বিকাশ</div>
        </div>
        <div><i class="fa fa-chevron-circle-right"></i></div>
      </div>
    </div>

    <div class="row" v-else>
      <div class="payment-agreement d-flex flex-column justify-content-center align-items-center">
        <img src="@/assets/img/logos/bkash-icon-logo.svg" alt="bkash-logo">
        <div class="add-account-title">আপনার বিকাশ একাউন্টি অ্যাড করুন </div>
        <input class="form-control" placeholder="018-xxxxxxx" v-model="phoneNo"
               maxlength="11"
               @keypress="numericFormat($event, phoneNo, 11)">
        <argon-button fullWidth color="dark"
                      variant="gradient"
                      class="my-4 mb-2"
                      style="background: #F42F75; color: #FFFFFF" @click="createPayment">সাবমিট করুন</argon-button>
      </div>
    </div>
  </div>
</template>

<script>
import {sendRequest} from '@/http/axios.method';
import Loader from "@/views/components/Loader";
import _ from "lodash";
import ArgonButton from "@/components/ArgonButton.vue";
import { numericFormat } from "@/helper/numberHelper";

export default {
  name: "BkashPayment",
  components: {
    Loader,
    ArgonButton
  },
  data() {
    return {
      loaderActive: false,
      numericFormat,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      user: [],
      paymentId: this.$route.query.payment_id,
      paymentType: this.$route.query.type,
      isOnDemand: JSON.parse(this.$route.query.is_on_demand),
      paymentResponse: [],
      activeAgreement: [],
      phoneNo: '',
      bkashOpen: false,
    }
  },
  created() {
    this.getUser();
  },
  methods: {
    getUser() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/user', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.user = response.data;
              this.activeAgreement = this.user.active_agreement;
              if (this.isOnDemand) {
                this.bkashOpen = _.isNull(this.activeAgreement.agreementID)
              }
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },

    createPayment() {
      this.loaderActive = true;
      let data = {
        id: this.paymentId,
        type: this.paymentType
      }
      let url = 'v2.0/paysenz/create-payment';
      if (this.isOnDemand && _.isNull(this.activeAgreement.agreementID)) {
        data = {
          payerReference: this.phoneNo,
        }
        url = 'v2.0/nagorik/create-agreement';
      }

      sendRequest('post', url, data, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.paymentResponse = response.data;
              if (response.data.errorCode === '00') {
                window.open(response.data.url, '_blank');
                return;
              }
              window.open(response.data.redirectUrl, '_blank');
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    }
  }
}
</script>

<style scoped>

</style>
